module.exports = __webpack_public_path__ + "static/media/ProfileIcon.7deb3826.svg";